import { a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SearchInput from './SearchInput.js';
import { u as usePrevious } from './usePrevious-edd83563.js';
import { I as IntlProvider } from './provider-936ecd10.js';
import { i as injectIntl } from './injectIntl-d3879c1a.js';
import './useKeyPress-dea8da08.js';
import './index-11bc5ac3.js';
import './_commonjsHelpers-17042db9.js';
import './PropTypes-e1e509ba.js';
import 'moment';
import './Input.js';
import './LoadingBlock.js';
import './tslib.es6-2748fcb6.js';
import './hoist-non-react-statics.cjs-50d12f04.js';
import './index-f5c6df27.js';

var BookingFlowComponent = (function (Page) {
  /**
   * This High order component is intended to resolve common issues that the library
   * components may have. If you find an issue that might appear in other components
   * and can be resolved generically, please fix it here.
   */
  var BookingFlowComponent = function BookingFlowComponent(props) {
    var language = props.language;
    return /*#__PURE__*/React__default.createElement(IntlProvider, {
      locale: language || 'en',
      key: language
    }, /*#__PURE__*/React__default.createElement(Page, props));
  };
  BookingFlowComponent.propTypes = {
    /**
     * Neccesary to create IntlProvider
     */
    // eslint-disable-next-line react/require-default-props
    language: PropTypes.string
  };
  return BookingFlowComponent;
});

var PropertiesFilterByName = function PropertiesFilterByName(props) {
  var value = props.value,
    onFilterProperties = props.onFilterProperties,
    isLoading = props.isLoading,
    resetAutocompleteFilters = props.resetAutocompleteFilters,
    setAutocompleteFilter = props.setAutocompleteFilter,
    autocompleteFilterApplied = props.autocompleteFilterApplied,
    searchInputCategoriesLabels = props.searchInputCategoriesLabels,
    searchInputIntlNotFindMessage = props.searchInputIntlNotFindMessage,
    searchInputPlaceHolder = props.searchInputPlaceHolder,
    filterOnClick = props.filterOnClick,
    onGetPlace = props.onGetPlace;
  var _useState = useState(value || ''),
    _useState2 = _slicedToArray(_useState, 2),
    propertyName = _useState2[0],
    setPropertyName = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    timer = _useState4[0],
    setTimer = _useState4[1];
  var prevValue = usePrevious(value);
  useEffect(function () {
    if (value !== prevValue && propertyName !== prevValue) {
      setPropertyName(value);
    }
  }, [prevValue, propertyName, value]);
  var handleOnChange = function handleOnChange(newValue) {
    clearTimeout(timer);
    var onChange = props.onChange;
    setPropertyName(newValue);
    var onChangeWithTimeOut = new Promise(function (resolve) {
      setTimer(setTimeout(function () {
        return resolve(onChange(newValue));
      }, 600));
    });
    return onChangeWithTimeOut;
  };
  return /*#__PURE__*/React__default.createElement(SearchInput, {
    disabled: isLoading,
    intlNotFindMessage: searchInputIntlNotFindMessage,
    onChange: handleOnChange,
    onFilterProperties: onFilterProperties,
    placeholder: searchInputPlaceHolder,
    resetFilterApplied: resetAutocompleteFilters,
    onFilterApplied: setAutocompleteFilter,
    autocompleteFilterApplied: autocompleteFilterApplied,
    categoriesLabels: searchInputCategoriesLabels,
    filterOnClick: filterOnClick,
    onGetPlace: onGetPlace
  });
};
PropertiesFilterByName.defaultProps = {
  value: '',
  autocompleteFilterApplied: '',
  filterOnClick: true,
  searchInputPlaceHolder: '',
  onGetPlace: function onGetPlace() {
    return {
      location: {
        latitude: null,
        longitude: null
      },
      distance: null
    };
  }
};
PropertiesFilterByName.propTypes = {
  filterOnClick: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onFilterProperties: PropTypes.func.isRequired,
  value: PropTypes.string,
  resetAutocompleteFilters: PropTypes.func.isRequired,
  setAutocompleteFilter: PropTypes.func.isRequired,
  autocompleteFilterApplied: PropTypes.string,
  searchInputCategoriesLabels: PropTypes.shape({
    locations: PropTypes.node,
    properties: PropTypes.node
  }).isRequired,
  searchInputIntlNotFindMessage: PropTypes.func.isRequired,
  onGetPlace: PropTypes.func,
  searchInputPlaceHolder: PropTypes.string
};
var PropertiesFilterByName$1 = BookingFlowComponent(injectIntl(PropertiesFilterByName));

export default PropertiesFilterByName$1;
//# sourceMappingURL=PropertiesFilterByName.js.map
